import { IconCalendar } from "@tabler/icons-react";
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInputWithIcon = ({ value, onChange }) => {
  // Fungsi untuk memformat tanggal ke "yyyy-MM-dd"
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Tetapkan tanggal default ke hari ini saat komponen pertama kali dimuat
  useEffect(() => {
    if (!value) {
      const today = formatDate(new Date());
      onChange(today);
    }
  }, [value, onChange]);

  const handleDateChange = (date) => {
    const formattedDate = formatDate(date);
    onChange(formattedDate);
  };

  return (
    <div className="input-group">
      {/* DatePicker */}
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={handleDateChange}
        className="form-control w-100"
        wrapperClassName="w-100" // Tambahkan class ke wrapper
        placeholderText="Select a date"
        dateFormat="yyyy-MM-dd"
        showPopperArrow={false} // Hilangkan popper arrow
        popperPlacement="bottom-start" // Posisi dropdown kalender
        portalId="root-datepicker" // Render ke elemen <body> dengan ID ini
      />
      {/* <input
        type="date"
        className="form-control"
        value={value}
        onChange={handleDateChange}
      /> */}

      {/* Ikon Kalender */}
      <span className="input-icon-addon">
        <IconCalendar size={20} />
      </span>
    </div>
  );
};

export default DateInputWithIcon;
